module.exports = __webpack_public_path__ + "18_hair_black.2adf63ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/18_hair_black.png
// module id = b9Uz
// module chunks = 0